import { template as template_1de92e185e974990b9c08fcdfcb92ffa } from "@ember/template-compiler";
import { action } from '@ember/object';
import Component from '@glimmer/component';
/**
  Renders a `<tr>` element and yields the cell component.
  ```hbs
  <body.row as |row|>
    <row.cell>
      {{person.firstName}} #{{index}}
    </row.cell>
    <row.cell>
      {{person.lastName}}
    </row.cell>
    <row.cell>
      {{person.points}}
    </row.cell>
  </body.row>
  ```
  Remember you can customize each `<tr>` class or `@onClick` handler based on the row data
  because you have access to it from the body component.

  ```hbs
  <table.body as |body person|>
    <body.row class={{if person.isInvalid "error"}} as |row|>
      <row.cell>
        {{person.firstName}}
      </row.cell>
      <row.cell>
        {{person.lastName}}
      </row.cell>
      <row.cell>
        {{person.points}}
      </row.cell>
    </body.row>
  </table.body>
  ```

  @class TBodyRow
  @yield {object} row
  @yield {Component} row.cell - the cell component
*/ // template imports
import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Cell from './row/cell.gjs';
export default class TBodyRow extends Component {
    static{
        template_1de92e185e974990b9c08fcdfcb92ffa(`
    {{! template-lint-disable no-invalid-interactive }}
    <tr
      class='{{@theme.tbodyRow}} {{@theme.row}}'
      {{on 'click' this.handleClick}}
      role={{if @onClick 'button'}}
      ...attributes
    >
      {{yield (hash cell=(component Cell theme=@theme parent=this columns=@columns))}}
    </tr>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    /**
   * Adds a click action to the row.
   *
   * @argument onClick
   * @type Function
   */ cells = [];
    registerCell(cell) {
        let index = this.cells.length;
        this.cells.push(cell);
        return index;
    }
    unregisterCell(cell) {
        let cells = this.cells;
        let index = cells.indexOf(cell);
        cells.splice(index, 1);
    }
    @action
    handleClick() {
        this.args.onClick?.(...arguments);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3Rib2R5L3Jvdy5nanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYWN0aW9uIH0gZnJvbSAnQGVtYmVyL29iamVjdCc7XG5cbmltcG9ydCBDb21wb25lbnQgZnJvbSAnQGdsaW1tZXIvY29tcG9uZW50JztcblxuLyoqXG4gIFJlbmRlcnMgYSBgPHRyPmAgZWxlbWVudCBhbmQgeWllbGRzIHRoZSBjZWxsIGNvbXBvbmVudC5cbiAgYGBgaGJzXG4gIDxib2R5LnJvdyBhcyB8cm93fD5cbiAgICA8cm93LmNlbGw-XG4gICAgICB7e3BlcnNvbi5maXJzdE5hbWV9fSAje3tpbmRleH19XG4gICAgPC9yb3cuY2VsbD5cbiAgICA8cm93LmNlbGw-XG4gICAgICB7e3BlcnNvbi5sYXN0TmFtZX19XG4gICAgPC9yb3cuY2VsbD5cbiAgICA8cm93LmNlbGw-XG4gICAgICB7e3BlcnNvbi5wb2ludHN9fVxuICAgIDwvcm93LmNlbGw-XG4gIDwvYm9keS5yb3c-XG4gIGBgYFxuICBSZW1lbWJlciB5b3UgY2FuIGN1c3RvbWl6ZSBlYWNoIGA8dHI-YCBjbGFzcyBvciBgQG9uQ2xpY2tgIGhhbmRsZXIgYmFzZWQgb24gdGhlIHJvdyBkYXRhXG4gIGJlY2F1c2UgeW91IGhhdmUgYWNjZXNzIHRvIGl0IGZyb20gdGhlIGJvZHkgY29tcG9uZW50LlxuXG4gIGBgYGhic1xuICA8dGFibGUuYm9keSBhcyB8Ym9keSBwZXJzb258PlxuICAgIDxib2R5LnJvdyBjbGFzcz17e2lmIHBlcnNvbi5pc0ludmFsaWQgXCJlcnJvclwifX0gYXMgfHJvd3w-XG4gICAgICA8cm93LmNlbGw-XG4gICAgICAgIHt7cGVyc29uLmZpcnN0TmFtZX19XG4gICAgICA8L3Jvdy5jZWxsPlxuICAgICAgPHJvdy5jZWxsPlxuICAgICAgICB7e3BlcnNvbi5sYXN0TmFtZX19XG4gICAgICA8L3Jvdy5jZWxsPlxuICAgICAgPHJvdy5jZWxsPlxuICAgICAgICB7e3BlcnNvbi5wb2ludHN9fVxuICAgICAgPC9yb3cuY2VsbD5cbiAgICA8L2JvZHkucm93PlxuICA8L3RhYmxlLmJvZHk-XG4gIGBgYFxuXG4gIEBjbGFzcyBUQm9keVJvd1xuICBAeWllbGQge29iamVjdH0gcm93XG4gIEB5aWVsZCB7Q29tcG9uZW50fSByb3cuY2VsbCAtIHRoZSBjZWxsIGNvbXBvbmVudFxuKi9cbi8vIHRlbXBsYXRlIGltcG9ydHNcbmltcG9ydCB7IGhhc2ggfSBmcm9tICdAZW1iZXIvaGVscGVyJztcbmltcG9ydCB7IG9uIH0gZnJvbSAnQGVtYmVyL21vZGlmaWVyJztcbmltcG9ydCBDZWxsIGZyb20gJy4vcm93L2NlbGwuZ2pzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVEJvZHlSb3cgZXh0ZW5kcyBDb21wb25lbnQge1xuICA8dGVtcGxhdGU-XG4gICAge3shIHRlbXBsYXRlLWxpbnQtZGlzYWJsZSBuby1pbnZhbGlkLWludGVyYWN0aXZlIH19XG4gICAgPHRyXG4gICAgICBjbGFzcz0ne3tAdGhlbWUudGJvZHlSb3d9fSB7e0B0aGVtZS5yb3d9fSdcbiAgICAgIHt7b24gJ2NsaWNrJyB0aGlzLmhhbmRsZUNsaWNrfX1cbiAgICAgIHJvbGU9e3tpZiBAb25DbGljayAnYnV0dG9uJ319XG4gICAgICAuLi5hdHRyaWJ1dGVzXG4gICAgPlxuICAgICAge3t5aWVsZCAoaGFzaCBjZWxsPShjb21wb25lbnQgQ2VsbCB0aGVtZT1AdGhlbWUgcGFyZW50PXRoaXMgY29sdW1ucz1AY29sdW1ucykpfX1cbiAgICA8L3RyPlxuICA8L3RlbXBsYXRlPlxuXG4gIC8qKlxuICAgKiBBZGRzIGEgY2xpY2sgYWN0aW9uIHRvIHRoZSByb3cuXG4gICAqXG4gICAqIEBhcmd1bWVudCBvbkNsaWNrXG4gICAqIEB0eXBlIEZ1bmN0aW9uXG4gICAqL1xuXG4gIGNlbGxzID0gW107XG5cbiAgcmVnaXN0ZXJDZWxsKGNlbGwpIHtcbiAgICBsZXQgaW5kZXggPSB0aGlzLmNlbGxzLmxlbmd0aDtcbiAgICB0aGlzLmNlbGxzLnB1c2goY2VsbCk7XG4gICAgcmV0dXJuIGluZGV4O1xuICB9XG5cbiAgdW5yZWdpc3RlckNlbGwoY2VsbCkge1xuICAgIGxldCBjZWxscyA9IHRoaXMuY2VsbHM7XG4gICAgbGV0IGluZGV4ID0gY2VsbHMuaW5kZXhPZihjZWxsKTtcblxuICAgIGNlbGxzLnNwbGljZShpbmRleCwgMSk7XG4gIH1cblxuICBAYWN0aW9uXG4gIGhhbmRsZUNsaWNrKCkge1xuICAgIHRoaXMuYXJncy5vbkNsaWNrPy4oLi4uYXJndW1lbnRzKTtcbiAgfVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxTQUFTLE1BQU0sUUFBUSxnQkFBZ0I7QUFFdkMsT0FBTyxlQUFlLHFCQUFxQjtBQUUzQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXFDQSxHQUNBLG1CQUFtQjtBQUNuQixTQUFTLElBQUksUUFBUSxnQkFBZ0I7QUFDckMsU0FBUyxFQUFFLFFBQVEsa0JBQWtCO0FBQ3JDLE9BQU8sVUFBVSxpQkFBaUI7QUFFbEMsZUFBZSxNQUFNLGlCQUFpQjtJQUNwQyxNQUFBO1FBQUEsMENBQVUsQ0FBQTs7Ozs7Ozs7OztFQVVWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQVZBO0lBWVY7Ozs7O0dBS0MsR0FFRCxRQUFRLEVBQUUsQ0FBQztJQUVYLGFBQWEsSUFBSSxFQUFFO1FBQ2pCLElBQUksUUFBUSxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU07UUFDN0IsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUM7UUFDaEIsT0FBTztJQUNUO0lBRUEsZUFBZSxJQUFJLEVBQUU7UUFDbkIsSUFBSSxRQUFRLElBQUksQ0FBQyxLQUFLO1FBQ3RCLElBQUksUUFBUSxNQUFNLE9BQU8sQ0FBQztRQUUxQixNQUFNLE1BQU0sQ0FBQyxPQUFPO0lBQ3RCO0lBRUEsQ0FBQztJQUNELGNBQWM7UUFDWixJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sTUFBTTtJQUN6QjtBQUNGIn0